import React, { useState, useEffect, useRef } from 'react';

// Premium countdown timer component
// Updates every second without re-rendering parent
export const Countdown = ({ seconds: initialSeconds, onComplete }) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (initialSeconds <= 0) return;

    setSeconds(initialSeconds);

    intervalRef.current = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          onComplete?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [initialSeconds, onComplete]);

  if (seconds <= 0) return null;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const formatNum = (n) => n.toString().padStart(2, '0');

  return (
    <div className="countdown-premium">
      <style>{`
        .countdown-premium {
          display: flex;
          flex-direction: column;
          gap: 2px;
          margin-top: 6px;
          margin-left: 8px;
          animation: countdownGlow 2s ease-in-out infinite;
        }
        
        .countdown-premium .countdown-label {
          color: rgba(148, 163, 184, 0.9);
          font-size: 0.65rem;
          font-weight: 500;
        }
        
        .countdown-premium .countdown-time {
          font-size: 1.3rem;
          font-weight: 700;
          letter-spacing: 0.05em;
          background: linear-gradient(135deg, #38bdf8 0%, #818cf8 50%, #38bdf8 100%);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-variant-numeric: tabular-nums;
          text-shadow: 0 0 30px rgba(56, 189, 248, 0.5);
          filter: drop-shadow(0 0 8px rgba(56, 189, 248, 0.4));
          animation: countdownShine 3s ease-in-out infinite;
        }
        
        .countdown-premium .countdown-sep {
          -webkit-text-fill-color: rgba(129, 140, 248, 0.8);
          margin: 0 2px;
        }
        
        @keyframes countdownGlow {
          0%, 100% { opacity: 0.9; }
          50% { opacity: 1; }
        }
        
        @keyframes countdownShine {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>
      
      <span className="countdown-label">Odblokuje się za:</span>
      <span className="countdown-time">
        {hours > 0 && (
          <>
            {formatNum(hours)}
            <span className="countdown-sep">:</span>
          </>
        )}
        {formatNum(minutes)}
        <span className="countdown-sep">:</span>
        {formatNum(secs)}
      </span>
    </div>
  );
};

export default Countdown;
